<template>

    <div id="invite">

        <div class="mb-4">
            <h1 class="text-2xl font-medium text-gray-900 capitalize">Create Cost Index</h1>
        </div>

        <div class="flex flex-col" v-if="loaded">

            <ul class="top-help-block">
                <li><span class="text-brand-600">*</span> denotes required field</li>
            </ul>

            <form action="#" method="POST" @submit.prevent="form.createCostIndex()">

                <div class="panel">
                    <div class="panel-form">
                        <div class="panel-title">
                            <h3>Cost Index</h3>
                            <p>
                                The costing information associated with the cost index.
                            </p>
                        </div>
                        <div class="panel-section">
                            <div class="grid grid-cols-6 gap-6">
                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('id') }">
                                    <label for="id" class="block text-sm font-medium text-gray-700">Cost Index ID<i></i></label>
                                    <input type="text" name="id" id="id" v-model="form.data.id">
                                    <span v-if="form.fieldHasErrors('id')">{{ form.getFieldError('id') }}</span>
                                </div>

                                <p class="flex col-span-6 xl:col-span-4 -mt-4 text-sm text-gray-500 pb-4">
                                    An ID for the cost index e.g. SUB_1 or SUB1 (must only contain letters, numbers, dashes and underscore)
                                </p>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('discount_adjustment') }">
                                    <label for="discount_adjustment" class="block text-sm font-medium text-gray-700">Discount Adjustment<i></i></label>
                                    <input type="text" name="discount_adjustment" id="discount_adjustment" v-model="form.data.discount_adjustment">
                                    <span v-if="form.fieldHasErrors('discount_adjustment')">{{ form.getFieldError('discount_adjustment') }}</span>
                                </div>

                                <p class="flex col-span-6 xl:col-span-4 -mt-4 text-sm text-gray-500 pb-4">
                                    The discount reduction for a product e.g. a 1.00 discount adjustment would reduce a 5% product discount to 4%, if the
                                    products discount is less than the adjustment no discount will be given.
                                </p>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('transaction_fee') }">
                                    <label for="transaction_fee" class="block text-sm font-medium text-gray-700">Transaction Fee<i></i></label>
                                    <input type="text" name="transaction_fee" id="transaction_fee" v-model="form.data.transaction_fee">
                                    <span v-if="form.fieldHasErrors('transaction_fee')">{{ form.getFieldError('transaction_fee') }}</span>
                                </div>

                                <p class="flex col-span-6 xl:col-span-4 -mt-4 text-sm text-gray-500 pb-4">
                                    The transaction fee added to every order item e.g. a fee of 0.10; ordering 2 digital codes would add 0.20 a transaction fee to
                                    the order.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex mt-6 justify-end">
                    <div class="flex border-l-4 border-brand-500 bg-white text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-brand-400" v-if="form.successful()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <p class="text-gray-700 text-sm">
                            {{ form.getSuccessMessage() }}
                        </p>
                    </div>

                    <div class="flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-error-400" v-if="form.hasError()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p class="text-error-500 text-sm">
                            {{ form.getErrorMessage() }}
                        </p>
                    </div>
                    <button type="submit" class="btn-outline justify-center px-6 ml-6" @click.prevent="goBack">
                        Go Back
                    </button>
                    <button type="submit" class="btn justify-center px-6 ml-4" :disabled="form.isFormUpdating()">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="form.isFormUpdating()">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Create Cost Index
                    </button>
                </div>

            </form>

        </div>
        <Loading v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {CostIndex} from "../../app/Payment/CostIndex";
import {NavigationMixin} from "../../support/mixins";

export default {
    name: "AccountInvite",
    mixins: [NavigationMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {

            vm.form = new CostIndex();

            resolve(true);

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


